// src/components/news/NewsBackButton.jsx
import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";

const NewsBackButton = ({ to = "/news", label = "Back to News" }) => {
  if (!to) return null;

  return (
    <Link
      to={to}
      className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/40 bg-white/10 text-sm font-medium text-white/90 hover:bg-white hover:text-gray-900 hover:border-transparent transition-colors duration-200 shadow-sm hover:shadow-md"
    >
      <ArrowLeftIcon className="h-4 w-4" />
      <span>{label}</span>
    </Link>
  );
};

export default NewsBackButton;


